import { SnutenState } from './interface';

const getSnuten = (state: SnutenState): SnutenState => state;

const selectors = {
  getSnuten
};

export default selectors;
